import { useSearchParams, useNavigate } from 'react-router-dom'
import { useAuth } from '@praxis/component-auth'
import { useEnv } from '@praxis/component-runtime-env'
import { useAnalytics } from '@praxis/analytics/client'
import {
  PARAM_SUPPLIER_ID,
  PARAM_LOCATION_ID,
  PARAM_MANUFACTURING_TYPE_ID,
  PARAM_ACTIVE_TAB,
  PARAM_ACTIVE_COMMENTS_TAB,
} from '../../common/commonConstants'
import { Rfi3Provider } from './RFI3Landing/context/Rfi3Context'
import Rfi3LandingContainer from './RFI3Landing/components/Rfi3LandingContainer'

const RFI3Landing = (props) => {
  const auth = useAuth()
  const env = useEnv()
  const navigate = useNavigate()
  const { sendEvent } = useAnalytics()
  const [urlParam] = useSearchParams()

  const supplierId = urlParam.get(PARAM_SUPPLIER_ID)
  const locationId = urlParam.get(PARAM_LOCATION_ID)
  const manufacturingTypeId =
    urlParam.get(PARAM_MANUFACTURING_TYPE_ID) ||
    env.mfelcm?.appConstants?.defaultManufacturingTypeId
  const targetTab = urlParam.get(PARAM_ACTIVE_TAB)
  const commentsTab = urlParam.get(PARAM_ACTIVE_COMMENTS_TAB)

  return (
    <Rfi3Provider
      supplierId={supplierId}
      locationId={locationId}
      manufacturingTypeId={manufacturingTypeId}
      targetTab={targetTab}
      commentsTab={commentsTab}
      userSettings={props.userSettings}
      auth={auth}
      env={env}
      sendEvent={sendEvent}
      navigate={navigate}
    >
      <Rfi3LandingContainer />
    </Rfi3Provider>
  )
}

export default RFI3Landing
